import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  PhoneCall,
  Mail,
  MapPin,
  ChevronRight,
  Clock,
  Calendar,
  Send,
  ArrowUp,
  Star,
  Instagram,
  Facebook,
  Twitter,
  Compass,
  Gift,
  Shield,
  Utensils,
  Coffee,
  Wifi,
  Waves,
  Menu,
  Clock3
} from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [isVisible, setIsVisible] = useState(false);
  const [showMobileLinks, setShowMobileLinks] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    // Handle subscription logic here
    setEmail('');
    alert('Thank you for subscribing!');
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Show scroll button only when scrolled down
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Close mobile menu when resizing to larger screen
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setShowMobileLinks(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <footer className="relative bg-gradient-to-b from-gray-900 via-gray-800 to-black text-gray-300 font-serif">
      {/* Newsletter subscription with hotel imagery backdrop */}
      {/* <div className="relative overflow-hidden bg-gradient-to-r from-gray-900 to-black py-12">
        <div className="absolute inset-0 opacity-10 bg-[url('https://ik.imagekit.io/tdlebsr5e/TheGulmoharGrand.jpeg?updatedAt=1750152666297')] bg-center bg-cover"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2">Stay Updated with Our Offers</h3>
            <p className="text-gray-400 mb-6">Subscribe to receive exclusive deals and updates from Gulmohar Grand Hotel</p>
            
            <form onSubmit={handleSubscribe} className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-lg mx-auto">
              <div className="relative w-full">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email address"
                  required
                  className="w-full px-4 py-3 rounded-lg bg-gray-800 border border-gray-700 text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent"
                />
              </div>
              <button 
                type="submit" 
                className="w-full sm:w-auto px-6 py-3 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-medium rounded-lg transition-all duration-300 flex items-center justify-center"
              >
                <Send size={18} className="mr-2" />
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </div> */}

      {/* Main footer content */}
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-8">

          {/* Logo and Address */}
          <div className="lg:col-span-4 mb-6">
            <div className="mb-8 p-6 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg border-l-4 border-amber-500 shadow-xl transform transition-transform duration-500 hover:-translate-y-1">
              <div className="flex flex-col items-center md:items-start">
                <img
                  src="https://ik.imagekit.io/tdlebsr5e/TheGulmoharGrand.jpeg?updatedAt=1750152666297"
                  alt="Gulmohar Grand"
                  className="h-20 object-contain mb-4"
                />
                <p className="text-sm text-gray-400 italic text-center md:text-left">Experience luxury in the heart of Himachal</p>
              </div>

              <div className="mt-6">
                <h3 className="text-lg font-bold text-white mb-4 border-b border-gray-700 pb-2 flex items-center">
                  <MapPin className="mr-2 text-amber-500" size={18} />
                  Our Address
                </h3>
                <div className="ml-6">
                  <p>
                    <span className="font-bold text-white">Gulmohar Luxe Hotels Pvt. Ltd.</span><br />
                    <a
                      href="https://devbhoomigroup.in"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" hover:underline"
                    >
                      Dev Bhoomi Group Companies
                    </a>
                    ,<br />
                    Admin Block at The Gulmohar Grand,<br />
                    8 mile stone, Una Chandigarh<br />
                    Highway Behdala, Una,<br />
                    Himachal Pradesh 174306
                  </p>
                </div>
              </div>
            </div>

            {/* Hotel services */}
            <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg p-6 shadow-xl">
              <h4 className="text-lg font-bold text-white mb-4 border-b border-gray-700 pb-2">Hotel Services</h4>
              <div className="grid grid-cols-2 gap-3">
                <div className="flex items-center group">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                    <Wifi className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                  </div>
                  <span className="text-sm">Free WiFi</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                    <Utensils className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                  </div>
                  <span className="text-sm">Restaurant</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                    <Waves className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                  </div>
                  <span className="text-sm">Swimming Pool</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                    <Shield className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                  </div>
                  <span className="text-sm">24/7 Security</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                    <Gift className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                  </div>
                  <span className="text-sm">Room Service</span>
                </div>
                <div className="flex items-center group">
                  <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                    <Coffee className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                  </div>
                  <span className="text-sm">Café</span>
                </div>
              </div>
            </div>
          </div>

          {/* Center columns */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {/* Reservation */}
            <div className="mb-6">
              <div className="p-6 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg shadow-xl h-full">
                <h3 className="text-lg font-bold text-white mb-4 border-b border-gray-700 pb-2 flex items-center">
                  <PhoneCall className="mr-2 text-amber-500" size={18} />
                  Reservation
                </h3>
                <div className="space-y-4">
                  <a href="tel:+916230562306" className="flex items-center space-x-3 group p-3 rounded-lg hover:bg-gray-700/50 transition-colors duration-300">
                    <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                      <PhoneCall className="text-amber-400 group-hover:text-white transition-colors duration-300" size={14} />
                    </div>
                    <span className="break-all">+91 (0) 6230562306</span>
                  </a>
                  <a href="tel:+91062305 62314" className="flex items-center space-x-3 group p-3 rounded-lg hover:bg-gray-700/50 transition-colors duration-300">
                    <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                      <PhoneCall className="text-amber-400 group-hover:text-white transition-colors duration-300" size={14} />
                    </div>
                    <span className="break-all">+91-062305 62314</span>
                  </a>
                  <a href="mailto:info@gulmohargrandhotel.com" className="flex items-center space-x-3 group p-3 rounded-lg hover:bg-gray-700/50 transition-colors duration-300">
                    <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                      <Mail className="text-amber-400 group-hover:text-white transition-colors duration-300" size={14} />
                    </div>
                    <span className="break-all">info@gulmohargrandhotel.com</span>
                  </a>
                  <a href="mailto:gm@gulmohargrandhotel.com" className="flex items-center space-x-3 group p-3 rounded-lg hover:bg-gray-700/50 transition-colors duration-300">
                    <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                      <Mail className="text-amber-400 group-hover:text-white transition-colors duration-300" size={14} />
                    </div>
                    <span className="break-all">gm@gulmohargrandhotel.com</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Grand Cinemaz and Opening Hours */}
            <div className="mb-6">
              <div className="p-6 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg shadow-xl h-full">
                <h3 className="text-lg font-bold text-white mb-4 border-b border-gray-700 pb-2 flex items-center">
                  <Compass className="mr-2 text-amber-500" size={18} />
                  Grand Cinemaz
                </h3>
                <div className="space-y-4">
                  <a href="tel:+916230301476" className="flex items-center space-x-3 group p-3 rounded-lg hover:bg-gray-700/50 transition-colors duration-300">
                    <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                      <PhoneCall className="text-amber-400 group-hover:text-white transition-colors duration-300" size={14} />
                    </div>
                    <span className="break-all">+91(0) 6230301476</span>
                  </a>
                  <a href="tel:+916230295069" className="flex items-center space-x-3 group p-3 rounded-lg hover:bg-gray-700/50 transition-colors duration-300">
                    <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center transition-colors duration-300">
                      <PhoneCall className="text-amber-400 group-hover:text-white transition-colors duration-300" size={14} />
                    </div>
                    <span className="break-all">+91(0) 6230295069</span>
                  </a>
                </div>

                {/* Opening Hours */}
                <div className="mt-6">
                  <h4 className="font-semibold text-white mb-3 border-b border-gray-700 pb-2 flex items-center">
                    <Clock3 className="mr-2 text-amber-500" size={16} />
                    Opening Hours
                  </h4>
                  <ul className="space-y-2">
                    <li className="flex justify-between">
                      <span className="text-sm">Monday - Friday</span>
                      <span className="text-sm text-amber-400">24 Hours</span>
                    </li>
                    <li className="flex justify-between">
                      <span className="text-sm">Saturday - Sunday</span>
                      <span className="text-sm text-amber-400">24 Hours</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Links and CTA */}
          <div className="lg:col-span-3 mb-6">
            <div className="p-6 bg-gradient-to-br from-gray-800 to-gray-900 rounded-lg shadow-xl h-full">
              <div className="flex justify-between items-center mb-4 border-b border-gray-700 pb-2">
                <h3 className="text-lg font-bold text-white">Quick Links</h3>
                <button
                  className="md:hidden bg-gray-700 hover:bg-amber-500 text-amber-400 hover:text-white p-2 rounded-lg transition-colors duration-300"
                  onClick={() => setShowMobileLinks(!showMobileLinks)}
                  aria-label="Toggle mobile links"
                >
                  <Menu size={18} />
                </button>
              </div>

              <ul className={`space-y-1 ${showMobileLinks ? 'block' : 'hidden md:block'}`}>
                {[
                  { label: "Our Legacy", path: "https://www.devbhoomigroup.in/about" },
                  { label: "Our Rooms", path: "/room-booking" },
                  { label: "Book Now", path: "/booking" },
                  { label: "About Us", path: "/about" },
                  { label: "Contact", path: "/contact" },
                  { label: "Terms and Conditions", path: "/terms-conditions" }
                ].map((link, index) => (
                  <li key={index}>
                    <Link
                      to={link.path}
                      className="flex items-center p-3 rounded-lg group hover:bg-gray-800 transition-all duration-300 transform hover:translate-x-1"
                    >
                      <div className="w-8 h-8 bg-gray-700 group-hover:bg-amber-500 rounded-full flex items-center justify-center mr-2 transition-colors duration-300">
                        <ChevronRight className="text-amber-400 group-hover:text-white transition-colors duration-300" size={16} />
                      </div>
                      <span className="group-hover:text-white transition-colors duration-300">{link.label}</span>
                    </Link>
                  </li>
                ))}
              </ul>


              {/* Social Media links */}
              <div className={`mt-6 ${showMobileLinks ? 'block' : 'hidden md:block'}`}>
                <h4 className="font-semibold text-white mb-3 border-b border-gray-700 pb-2">
                  Follow Us
                </h4>
                <div className="flex space-x-3">
                  <a href="https://m.facebook.com/thegulmohargrandhotel/" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 text-amber-400 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg">
                    <Facebook size={18} />
                  </a>
                  <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 text-amber-400 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg">
                    <Twitter size={18} />
                  </a>
                  <a href="https://www.instagram.com/thegulmohargrand?igsh=MWJydjdicDQ4a3RqYw==" className="w-10 h-10 bg-gray-800 hover:bg-amber-500 text-amber-400 hover:text-white rounded-full flex items-center justify-center transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg">
                    <Instagram size={18} />
                  </a>
                </div>
              </div>
            </div>

            {/* Book Now button for mobile view */}
            <div className="mt-4 flex justify-center md:hidden">
              <Link
                to="/room-booking"
                className="block w-full text-center py-4 bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white font-bold rounded-lg shadow-lg transition-all duration-300"
              >
                Book Your Stay Now
              </Link>
            </div>

          </div>
        </div>
      </div>

      {/* Bottom copyright section with enhanced styling */}
      <div className="border-t border-gray-800 py-6 bg-black">
        <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center">
          <div className="text-center md:text-left mb-4 md:mb-0">
            <p className="text-sm">
              © Copyright {new Date().getFullYear()} <span className="text-amber-500">The Gulmohar Grand</span>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-center">
            {/* <div className="flex flex-wrap justify-center gap-x-2 mb-3 sm:mb-0 sm:mr-6">
              <Link to="/privacy-policy" className="text-sm text-gray-400 hover:text-amber-400 transition-colors duration-300">Privacy Policy</Link>
              <span className="text-gray-600 hidden sm:inline">|</span>
              <Link to="/terms-and-conditions" className="text-sm text-gray-400 hover:text-amber-400 transition-colors duration-300">Terms of Use</Link>
              <span className="text-gray-600 hidden sm:inline">|</span>
              <Link to="/sitemap" className="text-sm text-gray-400 hover:text-amber-400 transition-colors duration-300">Sitemap</Link>
            </div> */}

            <p className="text-xs text-gray-500 mt-1">
              Designed and Maintained by{" "}
              <a
                href="https://dodunsoftsolutions.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-amber-400 hover:underline"
              >
                DODUN SOFT SOLUTIONS
              </a>
            </p>

          </div>
        </div>
      </div>

      {/* Scroll to top button with conditional rendering */}
      {/* {isVisible && (
        <button 
          onClick={scrollToTop} 
          className="bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 text-white p-3 rounded-full shadow-lg fixed bottom-6 right-6 z-50 transition-all duration-300 hover:scale-110 focus:outline-none"
          aria-label="Scroll to top"
        >
          <ArrowUp size={20} />
        </button>
      )} */}
    </footer>
  );
};

export default Footer;